import { io } from 'socket.io-client'
import { getEnvVars } from 'utils/envVars'

export const createNotificationSocket = token => {
  const endpoint = getEnvVars('REACT_APP_SOCKET_URL')
  if (!endpoint) return null

  const formattedToken = token ? (token.startsWith('Bearer ') ? token : `Bearer ${token}`) : null

  return io(endpoint, {
    path: getEnvVars('REACT_APP_SOCKET_PATH') || '/socket.io',
    transports: ['websocket', 'polling'],
    reconnectionAttempts: Infinity,
    reconnectionDelayMax: 8000,
    reconnectionDelay: 1000,
    autoConnect: true
    // withCredentials: true,
    // auth: formattedToken ? { token: formattedToken } : undefined
  })
}
